import React, { Component } from 'react';
import { Form, Input, Radio } from 'antd';
import { cloneDeep, get } from 'lodash';
import { language } from '../../../language';
import {
    ColorPicker,
    FormItemLayout,
    ConfigFormDecorator,
    NumberInput,
    EffectiveTime,
    UploadPicture,
} from '../../tools';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;

/**
 * 标题组件-配置表单
 */
class countDown extends Component<any> {
    effectiveTimeChange = (value: any) => {
        const { form, onChange } = this.props;
        const formValue = form.getFieldsValue();
        const { effectiveTime } = value;
        onChange({ ...formValue, effectiveTime });
    };

    onUpload = (path: string) => {
        this.change('leftPic', path);
    };
    onUploadBack = (path: string) => {
        this.change('backPic', path);
    };
    change = (type, val) => {
        let { onChange, value } = this.props;
        let newValue = {
            leftPic: get(value, 'leftPic', null),
            backPic: get(value, 'backPic', null),
            title: get(value, 'title', ''),
            text: get(value, 'text', ''),
            border: get(value, 'border', false),
            linkParams: get(value, 'linkParams', null),
            linkType: get(value, 'linkType', 'none'),
        };
        if (type !== 'linkTypes') {
            newValue[type] = val;
        } else {
            newValue['linkParams'] = val.linkParams;
            newValue['linkType'] = val.linkType;
        }
        onChange({ ...newValue });
    };

    render() {
        const {} = this.props;

        const {
            form: { getFieldDecorator },
            value,
            item,
            uploadAction,
            sourceRoot,
        } = this.props;
        const formItemLayout = FormItemLayout;
        return (
            <Form className="title-form">
                <FormItem {...formItemLayout} label={'左边图片'}>
                    <UploadPicture
                        sourceRoot={sourceRoot}
                        value={get(value, 'leftPic', '')}
                        uploadAction={uploadAction}
                        onChange={this.onUpload}
                    />
                </FormItem>
                <FormItem {...formItemLayout} label={'背景图片'}>
                    <UploadPicture
                        sourceRoot={sourceRoot}
                        value={get(value, 'backPic', '')}
                        uploadAction={uploadAction}
                        onChange={this.onUploadBack}
                    />
                </FormItem>
                {/*<FormItem {...formItemLayout} label={language.getText('components.Title.color')}>*/}
                {/*    {getFieldDecorator('fontColor')(<ColorPicker />)}*/}
                {/*</FormItem>*/}
                {/*<FormItem {...formItemLayout} label={language.getText('components.Title.size')}>*/}
                {/*    {getFieldDecorator('fontSize')(<NumberInput min={10} />)}*/}
                {/*</FormItem>*/}
                {/*<FormItem {...formItemLayout} label={language.getText('components.Title.align')}>*/}
                {/*    {getFieldDecorator('align')(*/}
                {/*        <RadioGroup className="align-style">*/}
                {/*            <Radio value={'left'}>*/}
                {/*                {language.getText('components.Title.left')}*/}
                {/*            </Radio>*/}
                {/*            <Radio value={'center'}>*/}
                {/*                {language.getText('components.Title.center')}*/}
                {/*            </Radio>*/}
                {/*            <Radio value={'right'}>*/}
                {/*                {language.getText('components.Title.right')}*/}
                {/*            </Radio>*/}
                {/*        </RadioGroup>*/}
                {/*    )}*/}
                {/*</FormItem>*/}
                <div style={{ marginLeft: 24 }}>
                    <EffectiveTime
                        value={{ effectiveTime: get(value, 'effectiveTime', null) }}
                        onChange={this.effectiveTimeChange}
                    />
                </div>
            </Form>
        );
    }
}

export const CountDown = ConfigFormDecorator(countDown);
